import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import visionLogo from "../assets/img/logo-vision.png";
import { IoMdLogOut } from "react-icons/io";
import { TiHome } from "react-icons/ti";
import { FaTicketSimple } from "react-icons/fa6";
import { AiFillAlert } from "react-icons/ai";
import { FaTruck } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import { MdWarehouse } from "react-icons/md";
import { MdScheduleSend } from "react-icons/md";
// import { MdOutlineFeedback } from "react-icons/md";
import RequestService from "../services/RequestService";
import NewRequestModal from './../components/modals/NewRequestModal';
import { Context } from '../context/UserContext'
import { IoSettingsOutline } from "react-icons/io5";
import { GrDeliver } from "react-icons/gr";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { FaRoute } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaUsers, FaBookOpen } from "react-icons/fa";
import { BsChatRightTextFill } from "react-icons/bs";
import SupportModal from "../components/modals/SupportModal";
import { GoPackageDependents } from "react-icons/go";
import DocsService from "../services/DocsService";
import { startPolling } from "../utils/polling";
import { podeGerenciarUsuarios } from "../utils/roles";




export default function SidebarAdmin() {

    const location = useLocation();
    const [newRequestModal, setNewRequestModal] = useState(false);
    const [gestaoQuantidade, setGestaoQuantidade] = useState()
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [showReports, setShowReports] = useState(false)
    const [showDocs, setShowDocs] = useState(false)
    // Lista de documentações de API, vinda do backend. Se a chamada falhar, o
    // submenu some e o item continua levando para o índice em /app/docs.
    const [docs, setDocs] = useState([])

    const [supportModal, setSupportModal] = useState(false);

    const { logout, user, authenticated } = useContext(Context)

    const handleNewRequest = async () => {
        setNewRequestModal(true)
    }

    const handleSupport = async () => {
        setSupportModal(true)
    }

    // Contador de Gestão. O sidebar fica em TODA página, então este ciclo roda
    // o tempo inteiro para todo usuário logado — e calculateSummary faz 8
    // countDocuments. Por isso usa o startPolling (60s e pausa com a aba em
    // segundo plano) em vez de um setInterval de 10s.
    useEffect(() => {
        if (!authenticated) return;

        const fetchSummary = async () => {
            const requestTodas = await RequestService.calculateSummary();
            setGestaoQuantidade(requestTodas?.totalGestao || null);
        };

        fetchSummary();
        return startPolling(fetchSummary);
    }, [authenticated]);

    // Lista de docs carregada uma vez, para alimentar o submenu de Documentação.
    useEffect(() => {
        if (!authenticated) return;

        let ativo = true;
        DocsService.listDocs()
            .then(({ docs }) => { if (ativo) setDocs(docs || []); })
            .catch(() => { if (ativo) setDocs([]); });

        return () => { ativo = false; };
    }, [authenticated]);

    return (
        <div className="flex flex-col justify-center items-center shadow h-full z-10 bg-white" 
            onMouseOver={() => setIsCollapsed(false)} 
            onMouseOut={() => setIsCollapsed(true)}
        >

            <div className="flex justify-center items-center w-full h-36">
                <img className={`mx-auto ${isCollapsed ? 'h-6 rotate-90' : 'h-12'} w-auto`} src={visionLogo} alt="Vision logo" />
            </div>

            {/* <button onClick={() => setIsCollapsed(!isCollapsed)} className="flex top-4 right-4 bg-red-200 p-2 rounded">
                {isCollapsed ? 'Expand' : 'Collapse'}
            </button> */}

            <div className={`flex flex-1 ${isCollapsed ? 'w-full' : 'w-52'} left-0 flex-col justify-start items-start gap-1`}>

                <Link to="/app/monitor" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${(location.pathname === '/app/monitor') || location.pathname === '/' ? ' bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaEye size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Monitor</span>}
                </Link>

                <Link to="/app" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${(location.pathname === '/app') || location.pathname === '/' ? ' bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <TiHome size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Backoffice</span>}
                </Link>

                <Link to="/app/warehouse" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/warehouse' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <MdWarehouse size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Depósito</span>}
                </Link>

                <Link to="/app/tosend" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/tosend' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <MdScheduleSend size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Repasse Entrega</span>}
                </Link>

                <Link to="/app/routedelivery" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/routedelivery' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaRoute size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Rota Entrega</span>}
                </Link>

                {/* COLETAS */}

                <Link to="/app/coletas" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/coletas' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaTruck size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Coletas</span>}
                </Link>

                <Link to="/app/gestao" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/gestao' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <AiFillAlert size={23} />
                    </div>
                    {!isCollapsed && <div className="w-5 h-5 flex bg-red-400 justify-center items-center rounded-full absolute right-4 top-3">
                        <div className="flex justify-center items-center w-4 h-4 text-sm text-black font-semibold">{gestaoQuantidade ? gestaoQuantidade : "0"}</div>
                    </div>}
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Gestão</span>}
                </Link>

               
                <Link
                    // to="/app/requests"
                    className="w-full h-10 relative flex items-center hover:bg-indigo-100"
                    onMouseOver={() => setShowReports(true)}
                    onMouseOut={() => setShowReports(false)}
                >
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/requests' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaTicketSimple size={23} />
                    </div>
                    {!isCollapsed && (
                        <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Geral/Relatórios</span>
                    )}

                    {showReports && (
                        <div className="absolute left-full top-0 py-2 bg-indigo-300 shadow-lg z-50">
                            <Link
                                to="/app/report1"
                                className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                            >
                                {/* <div className={`w-full h-full absolute ${location.pathname === '/app/report1' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} /> */}
                                <div className={`w-full h-full absolute`} />
                                <HiOutlineDocumentReport className="mr-2" size={17} />
                                <span className="text-neutral-900 text-xs text-nowrap">Consulta Gerencial Atendimento</span>
                            </Link>
                            <Link
                                to="/app/report2"
                                className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                            >
                                <div className={`w-full h-full absolute`} />
                                <HiOutlineDocumentReport className="mr-2" size={17} />
                                <span className="text-neutral-900 text-xs text-nowrap">Consulta Gerencial Coletas</span>
                            </Link>
                            <Link
                                to="/app/bireports"
                                className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                            >
                                <div className={`w-full h-full absolute`} />
                                <HiOutlineDocumentReport className="mr-2" size={17} />
                                <span className="text-neutral-900 text-xs text-nowrap">Power BI</span>
                            </Link>
                            <Link
                                to="/app/qualificationreport"
                                className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                            >
                                <div className={`w-full h-full absolute`} />
                                <HiOutlineDocumentReport className="mr-2" size={17} />
                                <span className="text-neutral-900 text-xs text-nowrap">Qualificação</span>
                            </Link>
                            <Link
                                to="/app/justificativas"
                                className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                            >
                                <div className={`w-full h-full absolute`} />
                                <HiOutlineDocumentReport className="mr-2" size={17} />
                                <span className="text-neutral-900 text-xs text-nowrap">Justificativas</span>
                            </Link>
                        </div>
                    )}
                </Link>
                

                

                <div className="w-full h-[0px] border mt-4 border-zinc-200"></div>

                <Link className="w-full h-10 relative hover:bg-indigo-100" onClick={handleNewRequest}>
                    <div className={`w-full h-10 left-0 top-0 absolute`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaPlus size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Nova Solicitação</span>}
                </Link>

                <Link to="/app/myrequests" className="w-full h-6 relative hover:bg-indigo-100">
                    <div className={`w-full h-6 left-0 top-0 absolute ${location.pathname === '/app/myrequests' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[5px] absolute">
                        <CiBoxList size={17} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[6px] absolute text-neutral-900 text-xs">Minhas Solicitações</span>}
                </Link>

                <Link to="/app/myreverses" className="w-full h-6 relative hover:bg-indigo-100">
                    <div className={`w-full h-6 left-0 top-0 absolute ${location.pathname === '/app/myreverses' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[5px] absolute">
                        <GrDeliver size={17}/>
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[6px] absolute text-neutral-900 text-xs">Minhas Coletas</span>}
                </Link>

                <div className="w-full h-[0px] border mt-4 border-zinc-200"></div>                

                <Link to="/app/homeentregador" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/homeentregador' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <GoPackageDependents size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Minhas Entregas</span>}
                </Link>

            </div>

            <div className={`flex flex-2 mb-2 ${isCollapsed ? 'w-full' : 'w-52'} left-0 flex-col justify-start items-start gap-1 sticky bottom-0 float-end bg-white`}>

                <Link className="w-full h-8 bg-gray-600 text-white relative hover:bg-indigo-500 flex items-center justify-center" onClick={handleSupport}>
                    <div className="flex items-center">
                        <BsChatRightTextFill size={15} />
                        {!isCollapsed && <span className="ml-2 text-sm">Suporte</span>}
                    </div>
                </Link>
                <div className="w-full h-[0px] border border-zinc-200" />

                {/* <Link to="/app/feedbacks" className="w-full h-12 relative hover:bg-indigo-100">
                    <div className={`w-full h-12 left-0 top-0 absolute ${location.pathname === '/app/feedbacks' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[12px] absolute">
                        <MdOutlineFeedback size={25} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[14px] absolute text-neutral-900 text-sm">Feedbacks</span>}
                </Link> */}

                <Link to="/app/admin" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/admin' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <IoSettingsOutline size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Admin</span>}
                </Link>

                { podeGerenciarUsuarios(user) &&

                <Link to="/app/usersadmin" className="w-full h-10 relative hover:bg-indigo-100">
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname === '/app/usersadmin' ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaUsers  size={23} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Users</span>}
                </Link>
                }

                {/* Documentação das APIs do Vision. A lista vem do backend
                    (DocsRoutes), então um doc novo aparece aqui sem alterar o
                    menu. O item em si leva para o índice, que lista tudo. */}
                <Link
                    to="/app/docs"
                    className="w-full h-10 relative flex items-center hover:bg-indigo-100"
                    onMouseOver={() => setShowDocs(true)}
                    onMouseOut={() => setShowDocs(false)}
                >
                    <div className={`w-full h-10 left-0 top-0 absolute ${location.pathname.startsWith('/app/docs') ? 'bg-indigo-300 border-l-4 border-black' : ''}`} />
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <FaBookOpen size={22} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Documentação</span>}

                    {showDocs && docs.length > 0 && (
                        <div className="absolute left-full top-0 py-2 bg-indigo-300 shadow-lg z-50">
                            {docs.map((doc) => (
                                <Link
                                    key={doc.slug}
                                    to={`/app/docs/${doc.slug}`}
                                    className="w-full h-8 relative flex items-center px-4 hover:bg-indigo-100"
                                >
                                    <div className={`w-full h-full absolute`} />
                                    <FaBookOpen className="mr-2" size={15} />
                                    <span className="text-neutral-900 text-xs text-nowrap">{doc.title}</span>
                                </Link>
                            ))}
                        </div>
                    )}
                </Link>

                <button onClick={logout} className="w-full h-10 relative hover:bg-indigo-100">
                    <div className="w-6 h-6 left-[18px] top-[8px] absolute">
                        <IoMdLogOut size={25} />
                    </div>
                    {!isCollapsed && <span className="left-[54px] top-[12px] absolute text-neutral-900 text-sm">Sair</span>}
                </button>

            </div>

            { user && authenticated &&
                <div className='absolute'>
                    <NewRequestModal
                        isModalOpen={newRequestModal}
                        setModalOpen={() => {
                            setNewRequestModal(!newRequestModal)
                        }}
                        user={user}
                        // ticketId={ticketOnModal}
                        // setTicketCb={setTicket}
                    ></NewRequestModal>

                    <SupportModal
                        isModalOpen={supportModal}
                        setModalOpen={() => {
                            setSupportModal(!supportModal)
                        }}
                    ></SupportModal>
                </div>
            }

        </div>
    );
}
